<template>
  <div class="wrap">
    <van-form class="aftermarket-form" ref="formRef">
      <van-field v-model="orderNumber" placeholder="请填写" input-align="right">
        <template #label>
          <span>物流单号</span>
          <span class="required-text">*</span>
        </template>
      </van-field>
      <van-field
        v-model="businessName"
        placeholder="请填写"
        input-align="right"
      >
        <template #label>
          <span>物流公司</span>
          <span class="required-text">*</span>
        </template></van-field
      >
    </van-form>
    <div class="upload-wrap">
      <div class="title">
        运费截图
        <span class="required-text">*</span>
      </div>
      <div class="upload-content">
        为保证符合条件下的运费退还，请上传相关凭证
        <van-uploader
          :max-count="5"
          :max-size="5 * 1024 * 1024"
          class="upload-btn"
          v-model="uploader"
          :before-read="beforeRead"
          multiple
        >
          <van-image
            :src="require('../../assets/images/upload-btn.png')"
            class="upload"
          />
        </van-uploader>
      </div>
    </div>
    <div class="account-wrap">
      <div class="title">
        填写运费收款账号
        <span class="required-text">*</span>
      </div>
      <div class="input-wrap">
        <input class="input" placeholder="请输入支付宝账号" v-model="account" />
      </div>
      <p class="account-text">7天无理由退货，运费商家承担。</p>
      <p class="account-text">7天以上退货，非质量问题运费由用户承担。</p>
    </div>
    <div class="footer">
      <div class="footer-btn active" @click="handleSubmit">提交</div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "@vue/composition-api";
import Vue from "vue";
import Compressor from "compressorjs";

import { uploadFlowPicture } from "@/apis";
import { submitAfterMarketInfo } from "@/apis/matter";
import { useRoute, useRouter } from "@/components/use/base";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const route = useRoute();
    const router = useRouter();
    const refundNumber = route.query.refundNumber;

    const formRef = ref(null);

    const orderNumber = ref("");
    const businessName = ref("");
    const account = ref("");
    const uploader = ref([]);

    const handleSubmit = async () => {
      if (!orderNumber.value) {
        vm.$toast("请输入物流单号");
        return;
      }
      if (!businessName.value) {
        vm.$toast("请输入物流公司");
      }
      if (!account.value) {
        vm.$toast("请输入支付宝账号");
        return;
      }
      if (!uploader.value.length) {
        vm.$toast("请上传运费截图");
        return;
      }
      const promises = uploader.value.map((item) =>
        uploadFlowPicture({
          data: item.content,
        })
      );
      const uploads = await Promise.all(promises);
      const urlList = uploads.map((item) => ({ image: item.data.url }));
      await submitAfterMarketInfo({
        refund_number: refundNumber,
        return_tracking_number: orderNumber.value,
        return_express_company: businessName.value,
        return_account_number: account.value,
        return_evidences: JSON.stringify(urlList),
      });
      vm.$toast("提交成功");
      router.go(-1);
    };

    const beforeRead = (file) => {
      return new Promise((resolve) => {
        new Compressor(file, {
          quality: 0.9,
          maxWidth: 1200,
          maxHeight: 1200,
          success: resolve,
          error() {
            this.$toast("图片上传失败，请重新上传");
          },
        });
      });
    };

    return {
      orderNumber,
      businessName,
      formRef,
      account,
      uploader,
      handleSubmit,
      beforeRead,
    };
  },
});
</script>

<style lang="less" scoped>
.wrap {
  background-color: rgb(245, 245, 245);
  min-height: 100vh;
  padding: 12px;
  box-sizing: border-box;
  position: relative;
}

.required-text {
  margin-left: 4px;
  font-weight: 400;
  font-size: 14px;
  color: #ff6430;
  line-height: 20px;
}

.aftermarket-form {
  padding-bottom: 11px;
  background-color: #fff;

  /deep/ &.van-form {
    border-radius: 8px;
    overflow: hidden;
  }

  /deep/ .van-field__label {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
  }

  /deep/ .van-field__body {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    text-align: right;
    input::placeholder {
      color: #999999;
    }
    input {
      color: #999999;
    }
  }
}

.title {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  .required-text {
    margin-left: 2px;
    line-height: 14px;
  }
}

.upload-wrap {
  margin-top: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(153, 153, 153, 0.1);
  border-radius: 8px;
  padding: 16px 12px;

  .upload-content {
    margin-top: 9px;
    background: #fafafa;
    border-radius: 4px;
    padding: 12px;

    font-weight: 400;
    font-size: 12px;
    color: #999999;
    line-height: 16px;

    .upload-btn {
      margin-top: 12px;

      .upload {
        height: 56px;
        width: 56px;
      }
    }
  }
}

.account-wrap {
  margin-top: 12px;
  background: #ffffff;
  box-shadow: 0px 0px 3px 0px rgba(153, 153, 153, 0.1);
  border-radius: 8px;
  padding: 16px 12px;

  .input-wrap {
    margin-top: 12px;
    background: #fafafa;
    border-radius: 4px;
    padding: 16px 12px;
    margin-bottom: 8px;

    .input {
      border: none;
      background: #fafafa;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      line-height: 16px;
      width: 100%;

      &::placeholder {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 16px;
      }
    }
  }

  .account-text {
    font-weight: 400;
    font-size: 10px;
    color: #cccccc;
    line-height: 16px;
  }
}

.footer {
  height: 96px;
  background: #ffffff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .footer-btn {
    margin: 0 auto;
    margin-top: 12px;
    width: 351px;
    height: 44px;
    background: #ececec;
    border-radius: 21px;

    font-weight: 500;
    font-size: 16px;
    color: #000000;
    line-height: 44px;
    text-align: center;

    &.active {
      background: linear-gradient(90deg, #dfbd94 0%, #ffe8c8 100%);
      color: #6c3e0c;
    }
  }
}
</style>
